export const adminSidebar = [
  {
    path: '',
    name: 'Dashboard',
    icon: 'dashboard-mono',
    end: true
  },
  {
    path: 'practices',
    name: 'Practices',
    icon: 'practice-mono',
    permission: 'practice.read'
  },
  {
    path: 'practitioners',
    name: 'Practitioners',
    icon: 'user-square-mono',
    permission: 'member.read'
  },
  {
    path: 'patients',
    name: 'Patients',
    icon: 'users-mono',
    permission: 'patients.read'
  },
  {
    path: 'reporting-center',
    name: 'Reporting Center',
    icon: 'document-text-mono'
  },
  {
    path: 'databank',
    name: 'Databank',
    icon: 'archive-mono'
  },
  {
    path: 'access-logs',
    name: 'Access Logs',
    icon: 'layers-mono',
    permission: 'user_events.read'
  },
  {
    path: 'users',
    name: 'Admin Users',
    icon: 'user-admin-mono'
  },
  {
    path: 'intelligence/ai_tasks',
    name: 'Intelligence',
    icon: 'myscribeai-mono',
    permission: ['ai_tasks.read', 'prompts.read', 'models.read'],
    isAny: true
  },
  {
    path: 'roles',
    name: 'Roles',
    icon: 'user-octagon-mono',
    permission: 'admin_role.read'
  },
  {
    path: 'dev-settings/feature-flags',
    name: 'Dev Settings',
    icon: 'code-1-mono',
    permission: 'admin_feature_flag.read'
  },
  {
    path: 'settings',
    name: 'Settings',
    icon: 'settings-mono'
  }
];
